
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import {
	RUNNITS_ACCESS_LEVEL,
} from '@run-diffusion/shared';
import { RUNNITS_OWNER_SELECTION } from "@/views/Runnits/constants";
import _trim from "lodash/trim";
import { ModelCRUDMixin, TeamUserMixin } from "@/mixins";

export default Vue.extend({
	name: 'RunnitModelStaticFields',
	props: {
		node: { type: Object, required: true },
	},
	mixins: [
		ModelCRUDMixin,
		TeamUserMixin,
	],
	data () {
		return {
			RUNNITS_ACCESS_LEVEL,
			RUNNITS_OWNER_SELECTION,
		};
	},
	computed: {
		...mapState([
			'runnitState',
			'modelsState',
			'loadingDraftRunnitNodeRun',
			'draftRunnitNodeRun',
		]),
		...mapGetters([
			'displayLabels',
		]),
		shouldRenderFields () {
			return !(this.loadingDraftRunnitNodeRun || this.loadingDraftRunnitNodeRun === null);
		},
		isNodeRunQueuing () {
			return !!(
				this.draftRunnitNodeRun &&
				this.node.id === this.draftRunnitNodeRun.nodeId &&
				this.runnitState.isQueuingDraftRunnitNodeRun
			);
		},
	},
	methods: {
		_trim

	},
});
